export default "__VITE_ASSET__C91w_7gd__"